import type { Property } from '@app/shared';

export const PROPERTY_KIND_LABELS: Record<Property['kind'], string> = {
  apartment: 'Appartement',
  house: 'Maison',
  parking: 'Parking',
  land: 'Terrain',
  other: 'Autre',
};

export const PROPERTY_USAGE_LABELS: Record<Property['usage'], string> = {
  'long-term-rental': 'Location longue durée',
  'short-term-rental': 'Location courte durée',
  vacant: 'Vacant',
  personal: 'Résidence personnelle',
};
